<div class="login-image">
    <img src="/login.png" alt="Login Image" />
  </div>
  